module.exports = __webpack_public_path__ + "static/media/car-is-wrong.a2169cb7.mp3";